import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit, OnDestroy {

  title: string;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  filesUploaded: boolean = false;

  public Files: File[] = [];

  @Input() accept: string;
  @Input() single: boolean;

  ngOnInit(): void {
  }

  onFilesChange(selectedFiles: FileList) {
    if (_.isNil(selectedFiles) || selectedFiles.length === 0) {
      return;
    }

    if (this.single) {
      this.Files.pop();
      this.Files.push(_.head(selectedFiles));
      return;
    }

    for (var i = 0; i < selectedFiles.length; i++) {
      this.Files.push(selectedFiles[i]);
    }
  }

  onFilesDrop(selectedFiles: Array<any>) {
    if (_.isNil(selectedFiles) || selectedFiles.length === 0) {
      return;
    }

    if (this.single) {
      this.Files.pop();
      this.Files.push(_.head(selectedFiles));
      return;
    }

    this.Files.push(...selectedFiles);
  }

  onDeleteFile(index: number): void {
    if (this.single) {
      this.Files.pop();
      return;
    }

    this.Files.splice(index, 1);
  }

  public get hasFiles(): boolean {
    return this.Files.length > 0;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
